export const REQUEST_GETPROFILEDATA = 'REQUEST_GETPROFILEDATA';
export const GETPROFILEDATA_RECEIVED = 'GETPROFILEDATA_RECEIVED';

